/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ category: NonNullable<unknown> }} Directory_Models_Section_DescriptionInputs */

const en_directory_models_section_description = /** @type {(inputs: Directory_Models_Section_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compare the currently listed ${i?.category} before opening the provider documentation.`)
};

const zh_directory_models_section_description = /** @type {(inputs: Directory_Models_Section_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在打开服务商文档前，先对比当前收录的${i?.category}。`)
};

/**
* | output |
* | --- |
* | "Compare the currently listed {category} before opening the provider documentation." |
*
* @param {Directory_Models_Section_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_models_section_description = /** @type {((inputs: Directory_Models_Section_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Models_Section_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_models_section_description(inputs)
	return zh_directory_models_section_description(inputs)
});
export { directory_models_section_description as "directory.models.section_description" }